import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["disabled"]

import { ref, PropType, watch, inject, Ref, computed } from 'vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'LockButton',
  props: {
    text: { type: String, required: true },
    asyncAction: {
        type: Function as PropType<() => Promise<any>>,
        required: true,
    },
    classes: {type: String, required: false, default: 'btn-primary' }
},
  setup(__props) {

const props = __props;

const isExecutingAction = ref(false);
const execute = inject<Ref<boolean>>('execute', ref(false));

watch(execute, (newVal) => {
    if (newVal) {
        executeAsyncAction();
    }
});

const executeAsyncAction = async () => {
    if (isExecutingAction.value) {
        return;
    }

    isExecutingAction.value = true;

    try {
        await props.asyncAction();
    } finally {
        isExecutingAction.value = false;
    }
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("button", {
    type: "button",
    onClick: executeAsyncAction,
    disabled: isExecutingAction.value,
    class: _normalizeClass(["btn px-5", __props.classes])
  }, _toDisplayString(__props.text), 11, _hoisted_1))
}
}

})